import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTiffToPngConfig } from '@/data/landingConfig/landingTiffToPngConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TiffToPng } from './schemaObject';

interface Props {}
const TiffToPngConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TiffToPng} />
			<LandingTemplate
				data={landingTiffToPngConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTiffToPng()}
			/>
		</>
	);
};

export default TiffToPngConverter;
